import { render } from "./TextPrimary.vue?vue&type=template&id=14a89e0a&scoped=true&bindings={\"size\":\"props\",\"weight\":\"props\",\"align\":\"props\",\"action\":\"props\",\"ml\":\"props\",\"mr\":\"props\"}"
import script from "./TextPrimary.vue?vue&type=script&lang=js"
export * from "./TextPrimary.vue?vue&type=script&lang=js"

import "./TextPrimary.vue?vue&type=style&index=0&id=14a89e0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14a89e0a"

export default script